export default function setAmplitudeCookies({ deviceId, sessionId }: { deviceId?: string; sessionId?: number }) {
  if (deviceId && sessionId) {
    document.cookie = `amplitudeDeviceId=${deviceId}; path=/;`
    document.cookie = `amplitudeSessionId=${sessionId}; path=/;`
  }
}
